// Common
import AutoSizedTextareaController from 'controllers/common/auto_sized_textarea_controller';
import FocusedInputController from 'controllers/common/focused_input_controller';
import TurboExternalRedirectController from 'controllers/common/turbo_external_redirect_controller';

// Comments
import JoinTokensController from 'controllers/website/newsletters/posts/show/join_tokens_controller';
import CommentsController from 'controllers/website/newsletters/posts/show/comments_controller';

setTimeout(() => {
  // Common
  window.Stimulus.register('auto-sized-textarea', AutoSizedTextareaController);
  window.Stimulus.register('focused-input', FocusedInputController);
  window.Stimulus.register('turbo-external-redirect', TurboExternalRedirectController);

  // Comments
  window.Stimulus.register('newsletter-post-show-comments', CommentsController);
  window.Stimulus.register('newsletter-post-show-join-tokens', JoinTokensController);
}, 0);
